<template>
  <!-- 大题型--针对完型填空、阅读理解、选词填空 -->
  <div>
    <!-- <div class="que_box" v-for="item in answersArr" :key="item.orders"> -->
    <!-- 题干 -->
    <div class="contain" v-for="it in item.answerJsonDetailDtos">
      学员作答：<span v-if="it.userAnswers" v-html="it.userAnswers"></span>
      <span v-else class="red">未作答</span>
    </div>
    <!-- 教师评分： -->
    <ul class="teacher_score" v-if="!isLook">
      <li>
        教师评分：
        <el-input style="width: 30%" type="number" v-model="item.score"
          @input="inputFunc(item.answerJsonDetailDtos[0].score, item.score, item.answerJsonDetailDtos[0].userAnswers)">
        </el-input>
        分
      </li>
      <!-- <li>
        教师评语：
        <el-input style="width: 86%" type="text" placeholder="请输入本题评语（可以留空）" v-model="item.comment" maxlength="100"
          show-word-limit>
        </el-input>
      </li> -->
    </ul>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "AnswersType",
  props: {
    // answersArr: Array,
    item: Object,
    isLook: {
      type: Boolean,
      default: false
    }
  },
  created() {
    // this.answersArr.forEach((item) => {
    this.item.title = this.item.title?.replace(
      /<img/g,
      "<img style='width:80px;height:auto;'"
    );
    if (this.item.answerJsonDetailDtos.contents) {
      this.item.answerJsonDetailDtos.contents = this.item.answerJsonDetailDtos.contents.replace(
        /<img/g,
        "<img style='width:80px;height:auto;'"
      );
    }
    // });
  },
  watch: {
    answersArr: {
      handler(newValue) {
        this.$emit("change-answers", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    inputFunc(scoreVal, val, studentVal) {
      // 判断当前是哪个input输入框改变
      console.log(studentVal, '123123');
      if (studentVal) {
        if (val > scoreVal) {
          this.$alert(
            "亲:试题分数不能大于[试题满分]请重新评分！",
            "友情提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.item.score = 0;
                this.$forceUpdate()
              },
            }
          );
          return false;
        }
      } else {
        this.$alert(
          "亲:此题未作答，无法评分！",
          "友情提示",
          {
            confirmButtonText: "确定",
            callback: (action) => {
              this.item.score = 0;
              this.$forceUpdate()
            },
          }
        );
        return false;
      }

    },
  },
};
</script>

<style scoped>
.contain {
  padding: 10px;
  box-sizing: border-box;
}
</style>